'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var CacheEntry =
/**
 * @param {String} msgID
 * @param {Array<String>} topics
 *
 * @constructor
 */
function CacheEntry(msgID, topics) {
  _classCallCheck(this, CacheEntry);

  this.msgID = msgID;
  this.topics = topics;
};

var MessageCache = /*#__PURE__*/function () {
  /**
   * @param {Number} gossip
   * @param {Number} history
   * @param {msgIdFn} msgIdFn a function that returns message id from a message
   *
   * @constructor
   */
  function MessageCache(gossip, history, msgIdFn) {
    _classCallCheck(this, MessageCache);

    /**
     * @type {Map<string, RPC.Message>}
     */
    this.msgs = new Map();
    /**
     * @type {Array<Array<CacheEntry>>}
     */

    this.history = [];

    for (var i = 0; i < history; i++) {
      this.history[i] = [];
    }
    /**
     * @type {Number}
     */


    this.gossip = gossip;
    /**
     * @type {Function}
     */

    this.msgIdFn = msgIdFn;
  }
  /**
   * Adds a message to the current window and the cache
   *
   * @param {rpc.RPC.Message} msg
   * @returns {void}
   */


  _createClass(MessageCache, [{
    key: "put",
    value: function put(msg) {
      var msgID = this.getMsgId(msg);
      this.msgs.set(msgID, msg);
      this.history[0].push(new CacheEntry(msgID, msg.topicIDs));
    }
    /**
     * Get message id of message.
     * @param {rpc.RPC.Message} msg
     * @returns {string}
     */

  }, {
    key: "getMsgId",
    value: function getMsgId(msg) {
      return this.msgIdFn(msg);
    }
    /**
     * Retrieves a message from the cache by its ID, if it is still present
     *
     * @param {String} msgID
     * @returns {rpc.RPC.Message}
     */

  }, {
    key: "get",
    value: function get(msgID) {
      return this.msgs.get(msgID);
    }
    /**
     * Retrieves a list of message IDs for a given topic
     *
     * @param {String} topic
     *
     * @returns {Array<String>}
     */

  }, {
    key: "getGossipIDs",
    value: function getGossipIDs(topic) {
      var msgIDs = [];

      for (var i = 0; i < this.gossip; i++) {
        this.history[i].forEach(function (entry) {
          var _iterator = _createForOfIteratorHelper(entry.topics),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var t = _step.value;

              if (t === topic) {
                msgIDs.push(entry.msgID);
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }

      return msgIDs;
    }
    /**
     * Shifts the current window, discarding messages older than this.history.length of the cache
     *
     * @returns {void}
     */

  }, {
    key: "shift",
    value: function shift() {
      var _this = this;

      var last = this.history[this.history.length - 1];
      last.forEach(function (entry) {
        _this.msgs.delete(entry.msgID);
      });
      this.history.pop();
      this.history.unshift([]);
    }
  }]);

  return MessageCache;
}();

module.exports = {
  CacheEntry: CacheEntry,
  MessageCache: MessageCache
};